module.exports = __webpack_public_path__ + "static/img/11.8b17228.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/eng/11.png
// module id = J1oi
// module chunks = 0